export function useStarredProfessionalConfiguration() {
  return { enabled: true } as const;
}
